import React, { FunctionComponent } from 'react';
import {
  Select as MUiSelect,
  FormControl,
  MenuItem,
  FormHelperText,
  Typography,
  SelectChangeEvent,
} from '@mui/material';
import UnfoldMore from '@mui/icons-material/UnfoldMore';
import cx from 'classnames';
import useStyles from './Select.styles';

interface IProps {
  id: string;
  name: string;
  placeholder: string;
  options: { id: string; value: string }[];
  labelText?: string;
  value?: string;
  onChange?: (event: SelectChangeEvent) => void;
  customClass?: string;
  errorMessage?: string;
  editable?: boolean;
  disabled?: boolean;
}

const Select: FunctionComponent<IProps> = ({
  id,
  name,
  placeholder,
  options,
  labelText,
  value,
  onChange,
  customClass = '',
  errorMessage,
  editable = true,
  disabled = false,
}) => {
  const classes = useStyles();
  const displayedValue = options.find((option) => option.id === value)?.value;

  return (
    <FormControl fullWidth className={cx({ [customClass]: customClass })}>
      <label
        className={cx(classes.label, {
          [classes.labelError]: errorMessage,
        })}
        htmlFor={id}
      >
        {labelText}
      </label>
      {editable ? (
        <>
          <MUiSelect
            disableUnderline
            name={name}
            IconComponent={UnfoldMore}
            value={value}
            onChange={onChange}
            displayEmpty
            renderValue={() => {
              if (displayedValue) {
                return <>{displayedValue}</>;
              }
              return <span className={classes.placeholder}>{placeholder}</span>;
            }}
            classes={{
              root: cx(classes.selectWrapper, {
                [classes.inputError]: errorMessage,
              }),
              icon: classes.selectIcon,
            }}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              }
            }}
            disabled={disabled}
          >
            {options.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </MUiSelect>
          {errorMessage && (
            <FormHelperText classes={{ root: classes.error }} error>
              {errorMessage}
            </FormHelperText>
          )}
        </>
      ) : (
        <Typography className={classes.text}>{displayedValue}</Typography>
      )}
    </FormControl>
  );
};

export default Select;
